// Generated on 2026-07-14T20:30:31.370Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "274656"
  },
  {
    "marca": "HONDA",
    "busquedas": "267985"
  },
  {
    "marca": "FORD",
    "busquedas": "218679"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "133161"
  },
  {
    "marca": "NISSAN",
    "busquedas": "120892"
  },
  {
    "marca": "KIA",
    "busquedas": "66449"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "61028"
  },
  {
    "marca": "MAZDA",
    "busquedas": "38620"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "37359"
  },
  {
    "marca": "JEEP",
    "busquedas": "35498"
  },
  {
    "marca": "ISUZU",
    "busquedas": "21724"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "12711"
  },
  {
    "marca": "BMW",
    "busquedas": "9085"
  },
  {
    "marca": "DODGE",
    "busquedas": "7152"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "6560"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "5895"
  },
  {
    "marca": "ACURA",
    "busquedas": "2185"
  },
  {
    "marca": "SCION",
    "busquedas": "2124"
  },
  {
    "marca": "SUBARU",
    "busquedas": "1784"
  },
  {
    "marca": "GMC",
    "busquedas": "1749"
  },
  {
    "marca": "MINI",
    "busquedas": "1719"
  },
  {
    "marca": "RAM",
    "busquedas": "1680"
  },
  {
    "marca": "MERCURY",
    "busquedas": "1030"
  },
  {
    "marca": "LEXUS",
    "busquedas": "958"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "821"
  },
  {
    "marca": "VOLVO",
    "busquedas": "726"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "611"
  },
  {
    "marca": "AUDI",
    "busquedas": "570"
  },
  {
    "marca": "HUMMER",
    "busquedas": "474"
  },
  {
    "marca": "SATURN",
    "busquedas": "442"
  },
  {
    "marca": "INFINITI",
    "busquedas": "399"
  },
  {
    "marca": "GEO",
    "busquedas": "346"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "235"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "233"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "230"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "215"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "102"
  },
  {
    "marca": "FIAT",
    "busquedas": "101"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "78"
  },
  {
    "marca": "BUICK",
    "busquedas": "71"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "68"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "46"
  },
  {
    "marca": "RENAULT",
    "busquedas": "38"
  },
  {
    "marca": "JMC",
    "busquedas": "37"
  },
  {
    "marca": "JAC",
    "busquedas": "16"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "13"
  },
  {
    "marca": "FOTON",
    "busquedas": "9"
  },
  {
    "marca": "ZNA",
    "busquedas": "9"
  },
  {
    "marca": "JIM",
    "busquedas": "7"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "CHERY",
    "busquedas": "5"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "TESLA",
    "busquedas": "4"
  },
  {
    "marca": "CHANGAN",
    "busquedas": "4"
  },
  {
    "marca": "SAAB",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "SMART",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
